module.exports = __webpack_public_path__ + "static/media/37.dbdfdf50.avif";